import { Box, Flex } from "@chakra-ui/react";
import React, { Fragment, useEffect } from "react";
import GameSelector from "../../components/v4Layout/GameSelector/GameSelector";
import { useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import PlatformSelectorV4 from "../../components/v4Layout/PlatformSelector/PlatformSelector_v4";
import useCheckLogin from "../../hook/useCheckLogin";
import GameTypeSelectorV4 from "../../components/v4Layout/GameTypeSelector/GameTypeSelector_v4";

const GamePlatformPageV4 = () => {
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { gameType, topGameList, newGameList } = isHandleAllGame;

  const { gameMainType } = useParams();

  const { isMachineUser } = useCheckLogin();

  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (gameMainType) {
  //     const current_type = routeMapping(gameMainType)?.origin;
  //     if (!gameType?.includes(current_type)) {
  //       return navigate("/slots");
  //     }
  //   }
  // }, [gameType, gameMainType]);
  return (
    <Fragment>
      {!isMachineUser && ( //機台使用者不顯示
        <Box as="section" px="common-y" display={{ base: "block", xl: "none" }}>
          <GameTypeSelectorV4 />
        </Box>
      )}
      {/*         
      {!isMachineUser && ( //機台使用者不顯示
        <Box as="section" pt="home-space" px="common-y">
          <SubListSelectorV4 forceShowAll />
        </Box>
      )} */}
      {/* <ExceptWrapper
        exceptGameType={[
          "live-casino",
          "sports",
          "lottery",
          "fish",
          "arcade",
          "block-chain",
          "table",
        ]}
      >
        <Box as="section" py="home-space" px="common-y">
          <CarouselV4 />
        </Box>
      </ExceptWrapper>
      <ExceptWrapper
        exceptGameType={[
          "live-casino",
          "sports",
          "lottery",
          "fish",
          "arcade",
          "block-chain",
          "table",
        ]}
      >
        <Box as="section" pb={{ md: "0", base: "home-space" }} px="common-y">
          <MarqueeListV2 />
        </Box>
      </ExceptWrapper> */}

      <Box
        overflowY="scroll"
        flex={1}
        id="scrollableDiv"
        h="100%"
        // py={{
        //   md: "home-space",
        //   base: "0",
        // }}
        // h={{
        //   base: "80vh",
        //   md: "auto",
        // }}
      >
        <Box //pb="home-space"
          pb={{
            base: "0px",
            sm: "home-space",
          }}
          px="common-y"
          mt={
            isMachineUser
              ? {
                  md: "25px",
                  base: "15px",
                }
              : "5px"
          }
        >
          <PlatformSelectorV4 />
        </Box>

        <Box py="home-space" px="common-y">
          {/* <SubListSelector /> */}
          <GameSelector />
        </Box>
      </Box>
    </Fragment>
  );
};

export default GamePlatformPageV4;
